import { getImmerPatches } from "../../../history/patch";
import { isLegacyActionRecord, isPatchBasedActionRecord } from "./predicates";
/**
 * Get all of the paths in the data that are modified by the patches in an action record.
 */
export function getAffectedPathsForActionRecord(actionRecord) {
    if (isLegacyActionRecord(actionRecord)) {
        return actionRecord.actionChangeDiff.map((change) => change.path ?? []);
    }
    else if (isPatchBasedActionRecord(actionRecord))
        return getImmerPatches(actionRecord.actionChangeDiff).forward.map((p) => p.path);
    // This is dumb and defensive, but because the IActionRecord type isn't a real discriminated union,
    // we need to throw as a base case.
    throw new Error(`cannot recognize format of action record: ${JSON.stringify(actionRecord)}`);
}
function getNewRoutesFromLegacyActionRecord(actionRecord) {
    return actionRecord.actionChangeDiff.flatMap((value) => {
        if (value.kind === "N" && value.path?.[0] === "routes") {
            return value.rhs;
        }
        else {
            return [];
        }
    });
}
function getNewRoutesFromPatchActionRecord(actionRecord) {
    const { forward } = getImmerPatches(actionRecord.actionChangeDiff);
    return forward.flatMap((value) => {
        if (value.path[0] == "routes" && value.op == "add") {
            return value.value;
        }
        return [];
    });
}
/**
 * Get the newly created routes from an action record, if it creates them.
 *
 * NOTE: This is less than ideal - we're assuming that the rhs here is a route, which ok you HOPE it is, but let's face
 * it, that means you're relying on an implementation detail of the patch.  It's probably OK,
 * but we should try to avoid crossing this API boundary when and if possible.
 *
 * @returns New routes, if any exist.  If there are none, an empty array is returned.
 */
export function getNewRoutesFromActionRecord(actionRecord) {
    if (isLegacyActionRecord(actionRecord))
        return getNewRoutesFromLegacyActionRecord(actionRecord);
    else if (isPatchBasedActionRecord(actionRecord))
        return getNewRoutesFromPatchActionRecord(actionRecord);
    // This is dumb and defensive, but because the IActionRecord type isn't a real discriminated union,
    // we need to throw as a base case.
    throw new Error(`cannot recognize format of action record: ${JSON.stringify(actionRecord)}`);
}
//# sourceMappingURL=getters.js.map